const INFO = {
	main: {
		title: "Luiz Sena - Desenvolvedor iOS",
		name: "Luiz Sena",
		email: "luizsena.dev@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/luizerz",
		linkedin: "https://www.linkedin.com/in/luiz-sena-ios/",
	},

	homepage: {
		title: "Desenvolvedor de Software",
		description:
			"Olá! Meu nome é Luiz Sena e sou Desenvolvedor iOS, com 4 anos em desenvolvimento de software, sendo 3 anos especializado em desenvolvimento iOS, WatchOS, MacOS e tvOS. Tenho experiência na construção de aplicativos iOS nativos escaláveis, seguros e confiáveis usando vários frameworks e tecnologias. Possuo experiencia com desenvolviemnto web e backend como API`s. Gosto de resolver problemas complexos e aprender novas habilidades. Sou apaixonado por criar código de alta qualidade que siga as melhores práticas e padrões do setor. Estou sempre em busca de novos desafios e oportunidades para crescer como desenvolvedor. Atualmente com 3 aplicativos na App Store.",
	},

	about: {
		title: "Meu nome é Luiz Sena e moro no Brasil, onde desenho o futuro.",
		description:
			"Trabalhei em vários projetos ao longo dos anos e estou orgulhoso do progresso que fiz. Trabalhei com Java e Angular na Itegra Tecnologia, onde tive a experiência de trabalhar em uma empresa consolidada. Mais tarde trabalhei na Apple Developer Academy no IFCE, esse lugar me tornou um verdadeiro especialista em Swift e seus frameworks, nele trabalhei em mais de 15 projetos. Muitos desses projetos são de código aberto e estão disponíveis para outros explorarem e contribuírem. Se você estiver interessado em algum dos projetos em que trabalhei, sinta-se à vontade para verificar o código e sugerir quaisquer melhorias ou aprimoramentos que possa ter em mente. Colaborar com outras pessoas é uma ótima maneira de aprender e crescer, e estou sempre aberto a novas ideias e feedback.",
	},

	articles: {
		title: "Sou apaixonado por ultrapassar os limites do que é possível e inspirar a próxima geração de inovadores.",
		description:
			"Coleção cronológica de minhas reflexões extensas sobre programação, liderança, design de produto e muito mais.",
	},

	projects: [

		{
			title: "Mythos: A Ascensão",
			description:
				"Jogo de cartas competitivo com tema mitológico grego. Ganhe e ascenda ao Olimpo.",
			logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/e0/1e/f2/e01ef2dd-875d-7225-7f0a-d2213066ba26/AppIcon-0-0-1x_U007ephone-0-sRGB-85-220.png/246x0w.webp",
			linkText: "View App",
			link: "https://apps.apple.com/pt/app/mythos-a-ascens%C3%A3o/id6469017317",
		},

		{
			title: "UXperience",
			description:
				"Aplicativo para estudo das Leis de UX, baseado no livro Leis da Psicologia Aplicadas à UX de Jon Yablonski.",
			logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/ac/14/3c/ac143cf5-5b3f-523c-cc1a-41186bab2eeb/AppIcon-0-1x_U007emarketing-0-7-0-85-220.png/246x0w.webp",
			linkText: "View App",
			link: "https://apps.apple.com/br/app/uxperience/id6444863495",
		},

		{
			title: "The Pilgrims",
			description:
				"The Pilgrims é um jogo multiplataforma de conhecimento geral que visa conhecer a cultura brasileira por meio da associação de um lugar, ilustrado em uma imagem, e um destino.",
			logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/d7/2d/62/d72d628a-126e-621c-4ee9-50550414ab99/AppIcon-1x_U007ephone-P3-85-220.png/246x0w.webp",
			linkText: "View App",
			link: "https://apps.apple.com/br/app/the-pilgrims/id6450370334",
		},
	],
};

export default INFO;
